module.controller('sampleDetailUpdateCtrl', [ '$q', '$rootScope', '$state', 'planSamplingService', 'alertService', 'ASEBIOL_CONSTANTS',
		sampleDetailUpdateCtrlFn ]);

function sampleDetailUpdateCtrlFn($q, $rootScope, $state, planSamplingService, alertService, ASEBIOL_CONSTANTS) {
	var vm = this;
	vm.operationType = $state.current.data.type;

	vm.idPlanSampling = $state.params.idPlan;
	vm.idSampling = $state.params.idSampling;
	vm.idSample = $state.params.idSample;
	vm.product = {
		id : $state.params.idProduct
	}

	vm.sample = {};
	vm.samplingAnalysisSelected = [];
	vm.samplingAnalysisInit = [];

	vm.loading = false;

	vm.DATE_FORMAT = ASEBIOL_CONSTANTS.DATE_FORMAT;

	vm.disabled = true;

	init();

	function init() {
		vm.loading = true;

		planSamplingService.getSampleDetailInfo(vm.idPlanSampling, vm.idSampling, vm.idSample).then(function(response) {
			vm.loading = false;
			var result = response.getData();

			vm.sample.scheduleDate = moment(result.scheduleDate, ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT).toDate();
			vm.sample.observations = result.observations;

			var elements = result.sampleAnalysis.map(function(e) {
				var map = {};
				map = e.technique;
				map.idSampleAnalysis = e.id;
				map.dilutionExpected = e.dilutionExpected;
				map.observations = e.observationsAnalysis;
				map.analysis = e.analysis;
				map.analysis.regulation = e.regulation;
				return map;
			});
			vm.samplingAnalysisInit = elements;
		}, function(response) {
			vm.loading = false;
		});
	}

	vm.onSamplingAnalysisChange = function(samplingAnalysis, typeOperation) {
		var deferred = $q.defer();

		if (typeOperation === 'create') {
			var createModel = {
				idRegulation : samplingAnalysis.analysis.regulation.id,
				idAnalysis : samplingAnalysis.analysis.id,
				idTechnique : samplingAnalysis.id,
				observationsAnalysis : samplingAnalysis.observations,
				dilutionExpected : samplingAnalysis.dilutionExpected
			};

			planSamplingService.addSampleAnalysis(vm.idPlanSampling, vm.idSampling, vm.idSample, createModel).then(function(response) {
				deferred.resolve();
			}, function(response) {
				deferred.reject();
			});
		} else if (typeOperation === 'remove') {
			// si solo queda 1 no se deja eliminar
			if (vm.samplingAnalysisSelected.length <= 1) {
				alertService.showDanger("No se puede eliminar!!! Debe quedar al menos una técnica asociada!!!");
				deferred.reject();
				return deferred.promise;
			}
			var idSampleAnalysis = getIdSamplingAnalysis(samplingAnalysis);
			planSamplingService.removeSampleAnalysis(vm.idPlanSampling, vm.idSampling, vm.idSample, idSampleAnalysis).then(function(response) {
				deferred.resolve();
			}, function(response) {
				deferred.reject();
			});
		} else {
			var updateModel = {
				observationsAnalysis : samplingAnalysis.observations,
				dilutionExpected : samplingAnalysis.dilutionExpected
			};
			var idSampleAnalysis = getIdSamplingAnalysis(samplingAnalysis);
			planSamplingService.updateSampleAnalysis(vm.idPlanSampling, vm.idSampling, vm.idSample, idSampleAnalysis, updateModel).then(function(response) {
				deferred.resolve();
			}, function(response) {
				deferred.reject();
			});
		}
		return deferred.promise;
	}

	vm.sendAction = function() {
		alertService.showSwtQuestion('Actualizar muestra', update);
	};

	function update() {
		var updateModel = {};

		updateModel.observations = vm.sample.observations;
		// updateModel.scheduleDate = moment(vm.sample.scheduleDate).format(
		// ASEBIOL_CONSTANTS.DATETIME_FORMAT_MOMENT);

		planSamplingService.updateSample(vm.idPlanSampling, vm.idSampling, vm.idSample, updateModel).then(function(response) {
			vm.loading = false;
			alertService.showSuccess('Muestra actualizada satisfactoriamente');
			$state.go('home.samplingHome', {
				idPlan : vm.idPlanSampling,
				idSampling : vm.idSampling
			});
		}, function(response) {
			vm.loading = false;
		});
	}

	function getIdSamplingAnalysis(samplingAnalysis) {
		var ele = vm.samplingAnalysisInit.find(function(sa) {
			return samplingAnalysis.id === sa.id;
		});
		if (!ele)
			return null;
		return ele.idSampleAnalysis;
	}
}